import type { Theme } from '@emotion/react';
import { typographyClasses } from '@mui/material';
import theme from 'providers/theme/theme';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ErrorPageStackStyles: StyleExtend<Theme> = {
  mt: 9.5,
  border: `1px solid ${theme.palette.customColors.lightGray}`,
  p: theme.spacing(3, 6, 6, 6),

  [`.${typographyClasses.h1}:first-of-type`]: {
    fontSize: '36px',
    lineHeight: '46px',
  },

  [theme.breakpoints.down('sm')]: {
    p: theme.spacing(3),
    mt: 7,

    [`.${typographyClasses.h1}:first-of-type`]: {
      fontSize: '24px',
      lineHeight: '30px',
    },
  },
};
